/*
 * @Author: your name
 * @Date: 2022-02-15 14:04:09
 * @LastEditTime: 2022-02-26 17:33:00
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dy-group-web/src/utils/global.js
 */
// 全局属性
export const globalObj = {
  title: process.env.VUE_APP_TITLE,
  timeout: 1000 * 60,//1min
  uploadTimeout: 1000 * 60 * 60,//1h
  // rsaKey:'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDGRwlhnhqSWWHQgUvBJPQL99DxIjeRHmIQ125Foz43SobKWi+LgW9qPrEHe/ynl7R4pQonN3PJYzACDJ9nDMOpppSzURiAuDWNyhH1W4JjGJDast7PCb7sq7fyYPFZ5HrPWZRWW+XdrrPw4nhSraXIg0ZSkITlbbh3lCorgl3lCQIDAQAB',
}
// 用户登录认证token
globalObj.getToken = function () {
  return localStorage.token || ''
}

globalObj.setToken = function (val) {
  localStorage.token = val
}

// envType : FLUTTER_ANDROID, FLUTTER_IOS
globalObj.getEnvType = function () {
  return localStorage.envType || ''
}

globalObj.setEnvType = function (val) {
  localStorage.envType = val
}

// appVersion app版本号
globalObj.getAppVersion = function () {
  return localStorage.appVersion || ''
}

globalObj.setAppVersion = function (val) {
  localStorage.appVersion = val
}

// ali-oss的配置参数
globalObj.ossInfo = {}
